var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSwap = function SvgSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.667 384h554.666l-68.266 51.2a42.667 42.667 0 0 0-8.534 59.733A42.667 42.667 0 0 0 682.667 512a42.667 42.667 0 0 0 25.6-8.533l170.666-128a42.667 42.667 0 0 0 0-67.84l-164.693-128a42.667 42.667 0 0 0-52.48 67.413l66.987 51.627h-558.08a42.667 42.667 0 0 0 0 85.333zm682.666 298.667H298.667l68.266-51.2a42.667 42.667 0 0 0-51.2-68.267l-170.666 128a42.667 42.667 0 0 0 0 67.84l164.693 128a42.667 42.667 0 0 0 26.027 8.96 42.667 42.667 0 0 0 33.706-16.64 42.667 42.667 0 0 0-7.253-59.733L295.253 768h558.08a42.667 42.667 0 0 0 0-85.333z"
  })));
};

export default SvgSwap;